<div class="app-container">
  <page-header [icon]="'far-tag'" [title]="'parameters'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/parameter']"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [label]="'parameter.create'"
          [title]="'parameter.create' | translate"
          [dataCyAttribute]="'go-parameter'"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'parameters'"
      (onSubmit)="queryParameters.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [totalItems]="totalItems()"
    >
      <form-row-input
        [model]="filters().name"
        (modelChange)="onNameFilterChange($event)"
        [icon]="'far-list'"
        [label]="'payment.name'"
        (keydown.enter)="queryParameters.refetch()"
        [dataCyAttribute]="'parameter-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'parameters'"
      [query]="queryParameters"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
